module.exports = "<div #toriContainer class=\"tori-web-agent-container\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/tori-web-agent/tori-web-agent.component.html
// module id = ../../../../../src/app/shared/components/tori-web-agent/tori-web-agent.component.html
// module chunks = main